"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePluginVersionFromStdout = void 0;
exports.parse = parse;
const stdout_1 = require("./stdout");
const digraph_1 = require("./digraph");
const dep_graph_1 = require("./dep-graph");
var stdout_2 = require("./stdout");
Object.defineProperty(exports, "parsePluginVersionFromStdout", { enumerable: true, get: function () { return stdout_2.parsePluginVersionFromStdout; } });
function parse(stdout, includeTestScope = false, verboseEnabled = false, mavenVerboseIncludeAllVersions = false) {
    const digraphs = (0, stdout_1.parseDigraphsFromStdout)(stdout);
    const mavenGraphs = (0, digraph_1.parseDigraphs)(digraphs, {
        mavenVerboseIncludeAllVersions,
    });
    const scannedProjects = [];
    for (const mavenGraph of mavenGraphs) {
        const depGraph = (0, dep_graph_1.buildDepGraph)(mavenGraph, includeTestScope, verboseEnabled);
        scannedProjects.push({ depGraph });
    }
    return {
        scannedProjects,
    };
}
//# sourceMappingURL=index.js.map